<script>
import Icon from '~/components/icon';

export default {
  components: {
    Icon
  },

  props: {
    text: {
      type: String,
      required: true
    },

    check: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    iconName() {
      return this.check ? 'check' : 'x';
    }
  }
};
</script>

<template>
  <div class="d-flex align-items-center ">
    <icon
      class="me-3"
      :name="iconName"
    />

    <span>{{ text }}</span>
  </div>
</template>
